Object.defineProperty(exports, "__esModule", { value: true });
exports.Paper = exports.Card = void 0;
var Card_1 = require("./Card");
Object.defineProperty(exports, "Card", { enumerable: true, get: function () { return Card_1.Card; } });
Object.defineProperty(exports, "Paper", { enumerable: true, get: function () { return Card_1.Paper; } });
exports.default = Card_1.Card;
//# sourceMappingURL=index.js.map